document.addEventListener("DOMContentLoaded", function () {
  // Inicializa o Swiper para as miniaturas
  const thumbSwiper = new Swiper(".swipper-imagens-prod", {
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    spaceBetween: 12,
    watchSlidesProgress: true,
  });

  // Inicializa o Swiper da galeria
  const galeriaSwiper = new Swiper(".swiper-galeria", {
    slidesPerView: "auto",
    spaceBetween: 16,
    centerInsufficientSlides: true,
    navigation: {
      prevEl: ".galeria-prev",
      nextEl: ".galeria-next",
    },
  });

  // Fallback manual para as setas da galeria
  const prevBtn = document.querySelector(".galeria-prev");
  const nextBtn = document.querySelector(".galeria-next");
  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      if (galeriaSwiper) galeriaSwiper.slidePrev();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      if (galeriaSwiper) galeriaSwiper.slideNext();
    });
  }

  // Event listener delegado para cliques em qualquer Swiper Slide da página
  document.addEventListener("click", function (e) {
    // 1. Cliques no Swiper de cima (imagens do produto)
    const prodSlide = e.target.closest(".swipper-imagens-prod .swiper-slide");
    if (prodSlide) {
      const mainImg = document.getElementById("main-product-img");
      const slides = document.querySelectorAll(".swipper-imagens-prod .swiper-slide");

      if (!prodSlide.classList.contains("active")) {
        slides.forEach((s) => s.classList.remove("active"));
        prodSlide.classList.add("active");

        const newSrc = prodSlide.getAttribute("data-large-img");
        if (newSrc && mainImg) {
          mainImg.style.opacity = "0";
          setTimeout(() => {
            mainImg.src = newSrc;
            mainImg.onload = function () {
              mainImg.style.opacity = "1";
            };
            if (mainImg.complete) {
              mainImg.style.opacity = "1";
            }
          }, 200);
        }
      }
    }

    // 2. Cliques no Swiper de baixo (galeria de fotos)
    const galSlide = e.target.closest(".swiper-galeria .swiper-slide");
    if (galSlide) {
      const galeriaMain = document.getElementById("galeria-main-img");
      const galeriaSlides = document.querySelectorAll(".swiper-galeria .swiper-slide");

      if (!galSlide.classList.contains("active")) {
        galeriaSlides.forEach((s) => s.classList.remove("active"));
        galSlide.classList.add("active");

        const newSrc = galSlide.getAttribute("data-galeria-img");
        if (newSrc && galeriaMain) {
          galeriaMain.style.opacity = "0";
          setTimeout(() => {
            galeriaMain.src = newSrc;
            galeriaMain.onload = function () {
              galeriaMain.style.opacity = "1";
            };
            if (galeriaMain.complete) {
              galeriaMain.style.opacity = "1";
            }
          }, 200);
        }
      }
    }
  });

  // Animação suave para os acordeões (.info-item)
  document.querySelectorAll(".info-item").forEach((el) => {
    const summary = el.querySelector("summary");
    const content = el.querySelector(".info-content");

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      // Evita spam de cliques enquanto anima
      if (el.classList.contains("is-animating")) return;
      el.classList.add("is-animating");

      if (el.hasAttribute("open")) {
        // Estado inicial para fechamento
        content.style.maxHeight = content.scrollHeight + "px";
        content.style.marginTop = "15px";
        content.offsetHeight; // trigger reflow

        // Transiciona para 0
        content.style.maxHeight = "0px";
        content.style.marginTop = "0px";

        setTimeout(() => {
          el.removeAttribute("open");
          el.classList.remove("is-animating");
        }, 300);
      } else {
        // Estado inicial para abertura
        el.setAttribute("open", "");
        content.style.maxHeight = "0px";
        content.style.marginTop = "0px";
        content.offsetHeight; // trigger reflow

        // Transiciona para o scrollHeight
        content.style.maxHeight = content.scrollHeight + "px";
        content.style.marginTop = "15px";

        setTimeout(() => {
          content.style.maxHeight = "none";
          el.classList.remove("is-animating");
        }, 300);
      }
    });
  });
});
